export default __webpack_public_path__ + "static/media/cognitive-icon.5181a6f2.svg";